(() => {
  const app = window.Digitaliz;
  if (!app) return;
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.toast) return;
  window.DigitalizModules.toast = true;

  const el = document.querySelector("[data-toast]");
  if (!el) return;

  let dismissTimer = null;

  function show(message, isError, duration) {
    clearTimeout(dismissTimer);

    // aria-hidden must be removed before textContent changes so the live
    // region is in the accessibility tree when the announcement fires.
    el.setAttribute("aria-hidden", "false");
    el.classList.toggle("is-error", isError);
    el.classList.add("is-visible");
    el.textContent = message;

    dismissTimer = setTimeout(hide, duration);
  }

  function hide() {
    clearTimeout(dismissTimer);
    el.textContent = "";
    el.setAttribute("aria-hidden", "true");
    el.classList.remove("is-visible", "is-error");
  }

  app.on(app.events.CART_ADD, () => {
    show(window.themeStrings.addedToCart || "Added to cart", false, 3000);
  });

  app.on(app.events.CART_ERROR, (detail) => {
    const message = detail?.error?.message || "Something went wrong.";
    show(message, true, 5000);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && el.classList.contains("is-visible")) {
      hide();
    }
  });

})();
